<template>
  <div class="resources--container">
    <div>
      <div @click="showNewResourcePopup" class="btn btn-sm btn-success">
        <f-awesome icon="plus"></f-awesome>
        Создать ресурс
      </div>
    </div>

    <div class="mrg-t-25">
      <div class="resource-item mrg-t-15" v-for="item in resourcesList" :key="item.id">
        <div class="resource-item-info">{{ item.name }} ({{ item.count }} шт.)</div>
        <div class="resource-item-actions mrg-t-5">
          <div @click="showEditResourcePopup(item.id)" class="btn btn-sm btn-outline-info">Открыть/Изменить</div>
          <div @click="showDeleteResourcePopup(item.id)" class="btn btn-sm btn-danger">Удалить</div>
        </div>
      </div>
    </div>

    <popup
      :closeButton="newResourcePopup.closeButton"
      :actionButton="newResourcePopup.actionButton"
      :actionClass="newResourcePopup.actionClass"
      :show="newResourcePopup.show"
      @closePopup="closeNewResourcePopup"
      @actionPopup="addResource"
    >
      <div slot="header">Добавление ресурса</div>
      <div slot="body">
        <div class="input-block">
          <label for="resource_name">Название ресурса</label>
          <input
              type="text"
              @focus="formError.name = ''"
              @blur="vResourceName"
              v-model="newResource.name"
              id="resource_name"
              required
          />
          <div class="form-error">{{ formError.name }}</div>
        </div>

        <div class="input-block">
          <label for="resource_name">Количество</label>
          <input
              type="number"
              @focus="formError.count = ''"
              @blur="vResourceCount"
              v-model="newResource.count"
              id="resource_name"
              required
          />
          <div class="form-error">{{ formError.count }}</div>
        </div>

        <div>
          <div>Выберите услуги, которые зависят от ресурса:</div>
          <service-list-for-new-staff
              :data="servicesList"
              @checked="updateCheckServList"
          ></service-list-for-new-staff>
        </div>
      </div>
    </popup>

    <popup
        :closeButton="editResourcePopup.closeButton"
        :actionButton="editResourcePopup.actionButton"
        :actionClass="editResourcePopup.actionClass"
        :show="editResourcePopup.show"
        @closePopup="closeEditResourcePopup"
        @actionPopup="editResourceSubmit"
    >
      <div slot="header">Изменение ресурса</div>
      <div slot="body">
        <div class="input-block">
          <label for="edit_resource_name">Название ресурса</label>
          <input
              type="text"
              @focus="formEditError.name = ''"
              @blur="vEditResourceName"
              v-model="editResource.name"
              id="edit_resource_name"
              required
          />
          <div class="form-error">{{ formEditError.name }}</div>
        </div>

        <div class="input-block">
          <label for="edit_resource_name">Количество</label>
          <input
              type="number"
              @focus="formEditError.count = ''"
              @blur="vEditResourceCount"
              v-model="editResource.count"
              id="edit_resource_name"
              required
          />
          <div class="form-error">{{ formEditError.count }}</div>
        </div>

        <div>
          <div>Выберите услуги, которые зависят от ресурса:</div>
          <service-list-for-new-staff
              :data="servicesList"
              :default-services="editSelectedServices.selectedServices"
              :default-modifications="editSelectedServices.selectedModifications"
              :reset="resetServListStaffForEdit"
              @checked="updateEditCheckServList"
          ></service-list-for-new-staff>
        </div>
      </div>
    </popup>

    <popup
        :closeButton="deleteResourcePopup.closeButton"
        :actionButton="deleteResourcePopup.actionButton"
        :actionClass="deleteResourcePopup.actionClass"
        :show="deleteResourcePopup.show"
        @closePopup="closeDeleteResourcePopup"
        @actionPopup="deleteResourceSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Ресурс будет удален без возможности восстановления. Продолжить?
      </div>
    </popup>

  </div>
</template>

<script>

import Popup from "../../Popup.vue";
import Validator from "../../libraries/Validator";
import ServiceListForNewStaff from "../staff/ServiceListForNewStaff.vue";
import resourceRepository from "../../../repositories/resource";

const validator = new Validator();

export default {
  name: "Resources",
  components: {ServiceListForNewStaff, Popup},
  data() {
    return {
      newResourcePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Создать",
        actionClass: "btn-success"
      },
      newResource: {
        name: '',
        count: 1,
        selectedServices: {selectedModifications: [], selectedServices: []},
      },
      formError: {
        name: '',
        count: '',
      },

      editResourcePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Сохранить",
        actionClass: "btn-success"
      },
      editResource: {
        id: 0,
        name: '',
        count: 1,
        selectedServices: {selectedModifications: [], selectedServices: []},
      },
      formEditError: {
        name: '',
        count: '',
      },
      editSelectedServices: {selectedModifications: [], selectedServices: []},
      resetServListStaffForEdit: 0,
      resourcesList: [],

      deleteResourcePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedResourceId: 0,
    };
  },
  props: {
    servicesList: Array
  },
  watch: {

  },
  computed: {
    validateResource() {
      let errorCount = 0;
      this.vResourceName().result === "error" ? errorCount++ : "";
      this.vResourceCount().result === "error" ? errorCount++ : "";

      return errorCount;
    },
  },
  methods: {
    closeDeleteResourcePopup() {
      this.deleteResourcePopup.show = false;
    },
    showDeleteResourcePopup(resourceId) {
      this.deletedResourceId = resourceId;
      this.deleteResourcePopup.show = true;
    },
    deleteResourceSubmit() {
      resourceRepository.delete({id: this.deletedResourceId}).then(() => {
        this.closeDeleteResourcePopup();
        this.showResources();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 5,
          color: "danger"
        });
      });
    },
    closeEditResourcePopup() {
      this.editResourcePopup.show = false;
      this.resetServListStaffForEdit++;
    },
    showEditResourcePopup(resourceId) {
      for (let key in this.resourcesList) {
        if (+this.resourcesList[key].id === +resourceId) {
          this.editResource.id = this.resourcesList[key].id;
          this.editResource.name = this.resourcesList[key].name;
          this.editResource.count = this.resourcesList[key].count;

          this.editResource.selectedServices.selectedModifications = [];
          this.editResource.selectedServices.selectedServices = [];
          this.editSelectedServices.selectedServices = [];
          this.editSelectedServices.selectedModifications = [];
          for (let keyServ in this.resourcesList[key].resourceServices) {
            if (this.resourcesList[key].resourceServices[keyServ].service_id) {
              this.editSelectedServices.selectedServices.push(
                  this.resourcesList[key].resourceServices[keyServ].service_id
              );
            } else if (this.resourcesList[key].resourceServices[keyServ].modification_id) {
              this.editSelectedServices.selectedModifications.push(
                  this.resourcesList[key].resourceServices[keyServ].modification_id
              );
            }
          }
        }
      }
      this.editResourcePopup.show = true;
    },
    editResourceSubmit() {
      const data = {
        id: this.editResource.id,
        name: this.editResource.name,
        count: this.editResource.count,
      };
      if (this.editResource.selectedServices.selectedServices.length > 0) {
        data.selectedServices = this.editResource.selectedServices.selectedServices;
      }
      if (this.editResource.selectedServices.selectedModifications.length > 0) {
        data.selectedModifications = this.editResource.selectedServices.selectedModifications;
      }
      resourceRepository.update(data).then(() => {
        this.closeEditResourcePopup();
        this.editResource = {
          id: 0,
          name: '',
          count: 1,
          selectedServices: {selectedModifications: [], selectedServices: []},
        };
        this.showResources();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 5,
          color: "danger"
        });
      });
    },
    closeNewResourcePopup() {
      this.newResourcePopup.show = false;
    },
    showNewResourcePopup() {
      this.newResourcePopup.show = true;
    },
    updateEditCheckServList(list) {
      this.editResource.selectedServices = list;
    },
    addResource() {
      const data = {
        name: this.newResource.name,
        count: this.newResource.count,
      };
      if (this.newResource.selectedServices.selectedServices.length > 0) {
        data.selectedServices = this.newResource.selectedServices.selectedServices;
      }
      if (this.newResource.selectedServices.selectedModifications.length > 0) {
        data.selectedModifications = this.newResource.selectedServices.selectedModifications;
      }
      resourceRepository.create(data).then(() => {
        this.closeNewResourcePopup();
        this.newResource = {
          name: '',
          count: 1,
          selectedServices: {selectedModifications: [], selectedServices: []},
        };
        this.showResources();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 5,
          color: "danger"
        });
      });
    },
    showResources() {
      resourceRepository.show().then(resp => {
        this.resourcesList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 5,
          color: "danger"
        });
      });
    },
    updateCheckServList(list) {
      this.newResource.selectedServices = list;
    },
    vResourceName() {
      let validate = validator.validate([
        {
          fieldName: "Название ресурса",
          value: this.newResource.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.name = validate.message)
          : (this.formError.name = "");
      return validate;
    },
    vResourceCount() {
      let validate = validator.validate([
        {
          fieldName: "Количество",
          value: this.newResource.count,
          type: "integer",
          minValue: 1,
          maxValue: 99
        }
      ]);
      validate.result == "error"
          ? (this.formError.count = validate.message)
          : (this.formError.count = "");
      return validate;
    },
    vEditResourceName() {
      let validate = validator.validate([
        {
          fieldName: "Название ресурса",
          value: this.editResource.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formEditError.name = validate.message)
          : (this.formEditError.name = "");
      return validate;
    },
    vEditResourceCount() {
      let validate = validator.validate([
        {
          fieldName: "Количество",
          value: this.editResource.count,
          type: "integer",
          minValue: 1,
          maxValue: 99
        }
      ]);
      validate.result == "error"
          ? (this.formEditError.count = validate.message)
          : (this.formEditError.count = "");
      return validate;
    },
  },
  created() {
    this.showResources();
  }
};
</script>

<style scoped lang="less">
.resource-item{
  width: 100%;
  padding: 10px;
  background-color: #F0F4F9;
  border-radius: 5px;
  box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);

  .resource-item-actions{
    text-align: right;
  }
}
</style>
